import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UnmountClosed } from 'react-collapse';
import moment from 'moment-timezone';

import { financeSetViewedFetch } from './../store/finances/actions';

import formatTime from './../utils/formatTime';

import Icon from './../components/Icon';
import classNames from './../utils/classNames';

const amountToString = value => {
    const isNegative = value < 0;
    if (isNegative) {
        value *= -1;
    }
    value = (value / 100).toFixed(2);
    return isNegative ? `($${value})` : `$${value}`;
};

const displayTarget = finance => {
    return {
        'order': 'Payment',
        'bonus': finance.amount > 0 ? 'Bonus' : 'Fine',
        'withdrawal': 'Withdrawal'
    }[finance.target] || finance.target
};

class FinancesTableRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    render() {
        const { finance, className, setViewed } = this.props;
        const { isOpen } = this.state;
        const payload = finance.payload;
        const unread = finance.target === 'bonus' && finance.mark === 'unread';
        const rowClassName = classNames(className, { 'not-read': unread }, { 'is-success': finance.amount > 0 });
        const collapseLinkClassName = classNames('lnk-collapse', { 'active': isOpen });
        return (
            <div className={rowClassName}>
                <div className="row vertical">
                    <div className="col-1"><Icon className="svg-icon" iconName="combined-shape" /></div>
                    <div className="col-6">{finance.status_display}</div>
                    <div className="col-4">{amountToString(finance.amount)}</div>
                    <div className="col-4">{displayTarget(finance)}</div>
                    <div className="col-12 finance-row-title">{!payload ? finance.title : <a className={collapseLinkClassName} onClick={this.onClick}>{finance.title}</a>}</div>
                    <div className="col-4">{formatTime(finance.created_at, 'd')}</div>
                    <div className="col-4">{unread &&
                        <button type="button" className="btn btn-light btn-small custom-hover" disabled={finance.isFetchingViewed} onClick={setViewed}>Mark as read</button>
                    }</div>
                </div>
                {!!payload &&
                    <UnmountClosed isOpened={isOpen}>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-6"></div>
                            <div className="col-4"></div>
                            <div className="col-4"></div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-2">Payment method:</div>
                                    <div className="col-3">{payload.payment_details}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2">Withdrawal ammount:</div>
                                    <div className="col-3">{amountToString(payload.amount)}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2">Withdrawal fee:</div>
                                    <div className="col-3">{amountToString(payload.fee)}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2">Net nithdrawal:</div>
                                    <div className="col-3">{amountToString(payload.net_withdrawal)}</div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-2">Requested on:</div>
                                    <div className="col-3">{formatTime(payload.requested_on, 'd')}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2">Requested before:</div>
                                    <div className="col-3">{formatTime(payload.expected_on, 'd')}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2">Payment due date:</div>
                                    <div className="col-3">{formatTime(moment(payload.expected_on).add(10, 'days'), 'd')}</div>
                                </div>
                            </div>
                            <div className="col-4"></div>
                            <div className="col-4"></div>
                        </div>
                    </UnmountClosed>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const finance = state.finances.items[ownProps.id];
    return { finance };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setViewed: () => dispatch(financeSetViewedFetch(ownProps.id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancesTableRow);



// WEBPACK FOOTER //
// ./src/components/FinancesTableRow.js